// Single source of truth for "where does this user land" — was duplicated
// (and could drift) across AuthCallback.jsx, App.js::ProtectedRoute and
// LandingPage.jsx. DI/fleet admins land on /admin like any other admin,
// since the DI tab lives inside AdminDashboard — no separate route needed.
export function resolveHomePath(user) {
  if (!user) return "/";
  if (user.role === "admin" || user.role === "super_admin") return "/admin";
  if (user.role === "instructor") return "/instructor";
  return "/dashboard";
}
